import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

const C = {
  bg: '#0a0e1a', card: '#111827', border: '#1f2937', accent: '#00D4AA',
  text: '#e2e8f0', muted: '#94a3b8', danger: '#f87171', warn: '#fbbf24', ok: '#34d399'
};
const MAANDEN = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
const fmtNL = (iso) => { if (!iso) return ''; const d = new Date(iso); return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }); };
const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');

export default function InzetReserveren() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [fout, setFout] = useState(null);
  const [typeId, setTypeId] = useState(null);
  const [maand, setMaand] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const [beschik, setBeschik] = useState({});
  const [van, setVan] = useState('');
  const [tot, setTot] = useState('');
  const [form, setForm] = useState({ aantal: 1, aanvrager_naam: '', aanvrager_email: '', aanvrager_telefoon: '', locatie_adres: '', reden: '', afdeling_project: '', ordernummer: '', meldingsnummer: '', loc_tekening: false, loc_markeren: false, verklaring_akkoord: false });
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);
  const [files, setFiles] = useState([]);

  const laad = useCallback(() => {
    fetch('/api/inzet-publiek/' + token)
      .then(r => r.json())
      .then(j => {
        if (!j.success) { setFout(j.message || 'Ongeldige link'); return; }
        setData(j);
        if (!typeId && j.types.length > 0) setTypeId(j.types[0].id);
      })
      .catch(() => setFout('Kan de pagina niet laden'));
  }, [token, typeId]);
  useEffect(() => { laad(); }, [laad]);

  useEffect(() => {
    if (!typeId) return;
    const vanM = iso(maand);
    const totM = iso(new Date(maand.getFullYear(), maand.getMonth() + 1, 0));
    fetch('/api/inzet-publiek/' + token + '/beschikbaarheid?type_id=' + typeId + '&van=' + vanM + '&tot=' + totM)
      .then(r => r.json())
      .then(j => {
        if (!j.success) return;
        const map = {};
        j.dagen.forEach(d => { map[String(d.dag).slice(0, 10)] = d; });
        setBeschik(map);
      })
      .catch(() => {});
  }, [token, typeId, maand, melding]);

  const klikDag = (dag) => {
    if (!van || (van && tot)) { setVan(dag); setTot(''); }
    else if (dag < van) { setVan(dag); }
    else { setTot(dag); }
  };

  const verstuur = () => {
    setMelding(null);
    if (!van || !tot) { setMelding({ t: 'fout', m: 'Kies eerst een periode in de kalender (start- en einddag).' }); return; }
    if (!form.aanvrager_naam || !form.aanvrager_email || !form.locatie_adres) {
      setMelding({ t: 'fout', m: 'Naam, e-mail en locatie zijn verplicht.' }); return;
    }
    if (!form.loc_tekening && !form.loc_markeren) { setMelding({ t: 'fout', m: 'Kies een locatiebepaling.' }); return; }
    if (!form.verklaring_akkoord) { setMelding({ t: 'fout', m: 'De verklaring is verplicht.' }); return; }
    setBezig(true);
    fetch('/api/inzet-publiek/' + token + '/aanvraag', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type_id: typeId, van_datum: van, tot_datum: tot, ...form })
    })
      .then(r => r.json())
      .then(j => {
        setBezig(false);
        if (!j.success) { setMelding({ t: 'fout', m: j.message || 'Versturen mislukt' }); return; }
        const klaar = () => {
          setVan(''); setTot(''); setFiles([]);
          setForm(f => ({ ...f, locatie_adres: '', reden: '', ordernummer: '', meldingsnummer: '', loc_tekening: false, loc_markeren: false, verklaring_akkoord: false }));
          laad();
        };
        if (files.length > 0 && j.aanvraag) {
          const fd = new FormData();
          files.forEach(fl => fd.append('bijlagen', fl));
          fetch('/api/inzet-publiek/' + token + '/aanvraag/' + j.aanvraag.id + '/bijlagen', { method: 'POST', body: fd })
            .then(r2 => r2.json())
            .then(j2 => { setMelding({ t: 'ok', m: j.message + (j2.success ? ' (' + j2.aantal + ' bijlage(n) toegevoegd)' : ' \u2014 bijlagen uploaden mislukte') }); klaar(); })
            .catch(() => { setMelding({ t: 'ok', m: j.message + ' \u2014 bijlagen uploaden mislukte' }); klaar(); });
        } else { setMelding({ t: 'ok', m: j.message }); klaar(); }
      })
      .catch(() => { setBezig(false); setMelding({ t: 'fout', m: 'Versturen mislukt' }); });
  };

  const stijlInput = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', background: '#0d1220', border: '1px solid ' + C.border, borderRadius: 8, color: C.text, fontSize: 14, outline: 'none' };
  const lbl = { fontSize: 12, color: C.muted, marginBottom: 4, display: 'block' };

  if (fout) return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.text, fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: C.card, border: '1px solid ' + C.border, borderRadius: 14, padding: 30, textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>🔒</div>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>Geen toegang</div>
        <div style={{ fontSize: 13, color: C.muted }}>{fout}. Neem contact op met uw contactpersoon.</div>
      </div>
    </div>
  );
  if (!data) return <div style={{ minHeight: '100vh', background: C.bg, color: C.muted, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif' }}>Laden…</div>;

  const type = data.types.find(t => t.id === typeId) || {};
  const eerste = new Date(maand.getFullYear(), maand.getMonth(), 1);
  const offset = (eerste.getDay() + 6) % 7;
  const dagenInMaand = new Date(maand.getFullYear(), maand.getMonth() + 1, 0).getDate();
  const vandaag = iso(new Date());
  const cellen = [];
  for (let i = 0; i < offset; i++) cellen.push(null);
  for (let d = 1; d <= dagenInMaand; d++) cellen.push(iso(new Date(maand.getFullYear(), maand.getMonth(), d)));
  const statusBadge = (s) => {
    const map = { aangevraagd: ['In behandeling', C.warn], actief: ['Goedgekeurd', C.ok], afgewezen: ['Afgewezen', C.danger], vervuld: ['Afgerond', C.muted], geannuleerd: ['Geannuleerd', C.muted], verlopen: ['Verlopen', C.muted] };
    const [txt, kleur] = map[s] || [s, C.muted];
    return <span style={{ fontSize: 11, fontWeight: 700, color: kleur, border: '1px solid ' + kleur, borderRadius: 999, padding: '2px 10px', whiteSpace: 'nowrap' }}>{txt}</span>;
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: 'Arial, sans-serif', padding: '20px 12px' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <div style={{ fontWeight: 800, fontSize: 24, letterSpacing: '-0.5px' }}>
            <span style={{ color: '#fff' }}>WOM</span><span style={{ color: C.accent }}>sys</span>
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: C.accent, border: '1px solid ' + C.accent, borderRadius: 999, padding: '3px 12px' }}>{data.partij.naam}</span>
        </div>

        <div style={{ background: C.card, border: '1px solid ' + C.border, borderRadius: 14, padding: 18, marginBottom: 14 }}>
          <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 12 }}>Reserveren</div>

          {data.types.length > 1 && (
            <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
              {data.types.map(t => (
                <button key={t.id} type="button" onClick={() => { setTypeId(t.id); setVan(''); setTot(''); }}
                  style={{ padding: '7px 14px', borderRadius: 999, fontSize: 13, cursor: 'pointer', border: '1px solid ' + (t.id === typeId ? C.accent : C.border), background: t.id === typeId ? 'rgba(0,212,170,0.12)' : 'transparent', color: t.id === typeId ? C.accent : C.muted, fontWeight: 600 }}>
                  {t.naam}
                </button>
              ))}
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <button type="button" onClick={() => setMaand(new Date(maand.getFullYear(), maand.getMonth() - 1, 1))} style={{ background: 'transparent', border: '1px solid ' + C.border, color: C.text, borderRadius: 8, padding: '6px 12px', cursor: 'pointer' }}>←</button>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 700 }}>{MAANDEN[maand.getMonth()]} {maand.getFullYear()}</div>
              <div style={{ fontSize: 11, color: C.muted }}>vrije {type.naam || ''}s per dag</div>
            </div>
            <button type="button" onClick={() => setMaand(new Date(maand.getFullYear(), maand.getMonth() + 1, 1))} style={{ background: 'transparent', border: '1px solid ' + C.border, color: C.text, borderRadius: 8, padding: '6px 12px', cursor: 'pointer' }}>→</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 3, marginBottom: 3 }}>
            {['ma','di','wo','do','vr','za','zo'].map(d => <div key={d} style={{ textAlign: 'center', fontSize: 11, color: C.muted }}>{d}</div>)}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 3 }}>
            {cellen.map((dag, i) => {
              if (!dag) return <div key={'x' + i} />;
              const b = beschik[dag];
              const vrij = b ? b.vrij : null;
              const vol = vrij === 0;
              const verleden = dag < vandaag;
              const inSel = van && ((tot && dag >= van && dag <= tot) || (!tot && dag === van));
              let kleur = C.muted, bgc = 'transparent', bord = C.border;
              if (!verleden && vrij != null) {
                if (vol) { kleur = C.danger; }
                else if (vrij <= Math.max(2, Math.ceil((b.capaciteit || 0) * 0.2))) { kleur = C.warn; }
                else { kleur = C.ok; }
              }
              if (inSel) { bgc = 'rgba(0,212,170,0.16)'; bord = C.accent; }
              return (
                <button key={dag} type="button" disabled={verleden || vol}
                  onClick={() => klikDag(dag)}
                  style={{ padding: '5px 2px', minHeight: 44, borderRadius: 7, border: '1px solid ' + bord, background: bgc, cursor: (verleden || vol) ? 'default' : 'pointer', opacity: verleden ? 0.35 : 1 }}>
                  <div style={{ fontSize: 10, color: C.muted, textAlign: 'left', paddingLeft: 3 }}>{parseInt(dag.slice(8), 10)}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: kleur, textAlign: 'center' }}>{vrij != null ? vrij : '·'}</div>
                </button>
              );
            })}
          </div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
            {van && tot ? <>Gekozen: <b style={{ color: C.text }}>{fmtNL(van)} t/m {fmtNL(tot)}</b> (plaatsen · ophalen)</>
              : van ? <>Start: <b style={{ color: C.text }}>{fmtNL(van)}</b> — kies nu de ophaaldag</>
              : 'Klik een dag voor plaatsen, daarna een dag voor ophalen.'}
          </div>
        </div>

        <div style={{ background: C.card, border: '1px solid ' + C.border, borderRadius: 14, padding: 18, marginBottom: 14 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Naam aanvrager *</label><input style={stijlInput} value={form.aanvrager_naam} onChange={e => setForm({ ...form, aanvrager_naam: e.target.value })} /></div>
            <div><label style={lbl}>Telefoon</label><input style={stijlInput} value={form.aanvrager_telefoon} onChange={e => setForm({ ...form, aanvrager_telefoon: e.target.value })} /></div>
          </div>
          <div style={{ marginBottom: 10 }}><label style={lbl}>E-mailadres *</label><input style={stijlInput} type="email" value={form.aanvrager_email} onChange={e => setForm({ ...form, aanvrager_email: e.target.value })} /></div>
          <div style={{ marginBottom: 10 }}><label style={lbl}>Locatie *</label><input style={stijlInput} placeholder="Straat + plaats" value={form.locatie_adres} onChange={e => setForm({ ...form, locatie_adres: e.target.value })} /></div>
          <div style={{ display: 'grid', gridTemplateColumns: '90px 1fr', gap: 10, marginBottom: 12 }}>
            <div><label style={lbl}>Aantal *</label><input style={stijlInput} type="number" min="1" value={form.aantal} onChange={e => setForm({ ...form, aantal: e.target.value })} /></div>
            <div><label style={lbl}>Reden / opmerking</label><input style={stijlInput} value={form.reden} onChange={e => setForm({ ...form, reden: e.target.value })} /></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
            <div><label style={lbl}>Afdeling / Project</label><input style={stijlInput} value={form.afdeling_project} onChange={e => setForm({ ...form, afdeling_project: e.target.value })} /></div>
            <div><label style={lbl}>Ordernummer</label><input style={stijlInput} value={form.ordernummer} onChange={e => setForm({ ...form, ordernummer: e.target.value })} /></div>
            <div><label style={lbl}>Meldingsnummer</label><input style={stijlInput} value={form.meldingsnummer} onChange={e => setForm({ ...form, meldingsnummer: e.target.value })} /></div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={lbl}>Locatiebepaling *</label>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: C.text, marginBottom: 6, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.loc_tekening} onChange={e => setForm({ ...form, loc_tekening: e.target.checked })} style={{ marginTop: 2 }} />
              <span>Tekening met exacte locatie bijgevoegd (mailen naar de behandelaar)</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: C.text, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.loc_markeren} onChange={e => setForm({ ...form, loc_markeren: e.target.checked })} style={{ marginTop: 2 }} />
              <span>Locatie wordt uiterlijk 1 werkdag v\u00f3\u00f3r plaatsing in het veld gemarkeerd (aangespoten)</span>
            </label>
          </div>
          <div style={{ marginBottom: 12, padding: '10px 12px', borderRadius: 8, border: '1px solid ' + C.border, background: '#0d1220' }}>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: C.text, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.verklaring_akkoord} onChange={e => setForm({ ...form, verklaring_akkoord: e.target.checked })} style={{ marginTop: 2 }} />
              <span>Ik verklaar dat de opgegeven locatie correct is bepaald en rekening houdt met aanwezige VRI-installaties en overige infrastructuur. *</span>
            </label>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={lbl}>Tekening / foto's (max 5 \u2014 jpg, png of pdf)</label>
            <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,.heic,.pdf" onChange={e => setFiles(Array.from(e.target.files || []).slice(0, 5))} style={{ color: C.muted, fontSize: 13, width: '100%' }} />
            {files.length > 0 && <div style={{ fontSize: 12, color: C.accent, marginTop: 4 }}>{files.length} bestand(en): {files.map(f => f.name).join(', ')}</div>}
          </div>
          {melding && (
            <div style={{ marginBottom: 12, padding: '10px 12px', borderRadius: 8, fontSize: 13, border: '1px solid ' + (melding.t === 'ok' ? C.ok : C.danger), color: melding.t === 'ok' ? C.ok : C.danger }}>{melding.m}</div>
          )}
          <button type="button" onClick={verstuur} disabled={bezig}
            style={{ width: '100%', padding: 13, borderRadius: 10, border: 'none', background: C.accent, color: '#062b23', fontWeight: 800, fontSize: 15, cursor: 'pointer', opacity: bezig ? 0.6 : 1 }}>
            {bezig ? 'Versturen…' : 'Aanvraag versturen'}
          </button>
        </div>

        {data.aanvragen.length > 0 && (
          <div style={{ background: C.card, border: '1px solid ' + C.border, borderRadius: 14, padding: 18 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 10 }}>Uw aanvragen</div>
            {data.aanvragen.map(a => (
              <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: '1px solid ' + C.border }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>#{a.id} · {a.aantal}x {a.type_naam}{a.locatie_adres ? ' · ' + a.locatie_adres : ''}</div>
                  <div style={{ fontSize: 12, color: C.muted }}>{fmtNL(a.van_datum)} t/m {fmtNL(a.tot_datum)}{a.status === 'afgewezen' && a.afwijs_reden ? ' · ' + a.afwijs_reden : ''}</div>
                </div>
                {statusBadge(a.status)}
              </div>
            ))}
          </div>
        )}
        <div style={{ textAlign: 'center', fontSize: 11, color: C.muted, marginTop: 16 }}>Reserveringen via WOMsys</div>
      </div>
    </div>
  );
}
